/**
 * GTD Action Context - WHERE and HOW an action can be performed
 * Following David Allen's context-based action organization
 */
export class ActionContext {
  private constructor(
    public readonly context: string,
    public readonly toolsRequired: string[] = [],
    public readonly location?: string
  ) {}

  static atComputer(tools: string[] = []): ActionContext {
    return new ActionContext('computer', tools);
  }

  static onPhone(tools: string[] = []): ActionContext {
    return new ActionContext('phone', tools);
  }

  static atCalls(tools: string[] = []): ActionContext {
    return new ActionContext('@calls', tools);
  }

  static atErrands(location: string = '', tools: string[] = []): ActionContext {
    return new ActionContext('@errands', tools, location);
  }

  static anywhere(tools: string[] = []): ActionContext {
    return new ActionContext('@anywhere', tools);
  }

  static atOffice(tools: string[] = []): ActionContext {
    return new ActionContext('office', tools, 'office');
  }

  static atHome(tools: string[] = []): ActionContext {
    return new ActionContext('home', tools, 'home');
  }

  static errands(location: string, tools: string[] = []): ActionContext {
    return new ActionContext('errands', tools, location);
  }

  static agendaFor(person: string): ActionContext {
    return new ActionContext('agenda', [], person);
  }

  static custom(context: string, tools: string[] = [], location?: string): ActionContext {
    return new ActionContext(context, tools, location);
  }

  equals(other: ActionContext): boolean {
    return this.context === other.context && 
           this.location === other.location &&
           JSON.stringify(this.toolsRequired) === JSON.stringify(other.toolsRequired);
  }

  toString(): string {
    // Return context directly if it already starts with @
    if (this.context.startsWith('@')) {
      return this.context;
    }
    // Add @ prefix for contexts that don't have it
    const base = `@${this.context}`;
    if (this.location) {
      return `${base} (${this.location})`;
    }
    return base;
  }
}